import { motion } from 'framer-motion'
import type { SlideProps } from '@/components/SlideWizard'
import peterImg from '@/assets/peter.png'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide2Peter.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide2Peter(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 mx-auto max-w-3xl">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2, ease }}
        className="w-full max-w-2xl border-s-4 border-slate-300 ps-6 sm:ps-8 text-start"
      >
        <p className="text-2xl sm:text-3xl text-slate-700 italic leading-relaxed">
          {c.quote}
        </p>
        <div className="mt-5 flex items-center gap-3">
          <img
            src={peterImg}
            alt={c.imageAlt}
            className="h-10 w-10 rounded-full object-cover"
          />
          <p className="text-lg sm:text-xl text-slate-400">
            {c.attribution}
          </p>
        </div>
        <p className="mt-3 text-sm font-medium text-slate-500">{c.illustrative}</p>
      </motion.div>
    </div>
  )
}
